declare global {
	interface Window {
		API_URL?: string;
		API_TOKEN?: string;
		SENTRY_DSN?: string;
		SENTRY_TRACES_SAMPLE_RATE?: number;
		SENTRY_REPLAYS_SESSION_SAMPLE_RATE?: number;
		SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE?: number;
		POST_MESSAGE_TARGET_ORIGIN?: string;
    YANDEX_METRIKA_ID?: string | number;
	}
}

export const HTTP_HOST = window.API_URL
	? window.API_URL
	: import.meta.env.VITE_API_URL;

export const TOKEN = window.API_TOKEN ? window.API_TOKEN : import.meta.env.VITE_API_TOKEN;
export const POST_MESSAGE_TARGET_ORIGIN = window.POST_MESSAGE_TARGET_ORIGIN || import.meta.env.VITE_POST_MESSAGE_TARGET_ORIGIN || '*';
export const YANDEX_METRIKA_ID = window.YANDEX_METRIKA_ID || import.meta.env.VITE_YANDEX_METRIKA_ID;